(function(){
  if(window.__IRONSIDE_PRICE_AR__)return;window.__IRONSIDE_PRICE_AR__=true;

  function numFromText(t){
    if(!t)return null;
    var s=String(t).replace(/\s/g,'').replace(/[^\d.,-]/g,'');
    if(!s)return null;
    if(s.indexOf(',')>-1)s=s.replace(/\./g,'').replace(',','.');
    else s=s.replace(/\./g,'');
    var n=parseFloat(s);
    return isNaN(n)?null:n;
  }

  function removeBadge(offerGroup){
    var b=offerGroup&&offerGroup.querySelector&&offerGroup.querySelector('.ironside-price-ar__badge');
    if(b) b.remove();
  }

  function ensure(pp){
    if(!pp||!pp.querySelector) return;

    var c=pp.querySelector('[ref="priceContainer"]');
    if(!c) return;

    var priceEl=c.querySelector('.price');
    if(!priceEl) return;

    var compareEl=c.querySelector('.compare-at-price');
    var offerGroup=(priceEl.closest&&priceEl.closest('[role="group"]'))||priceEl.parentElement;
    if(!offerGroup) return;

    // Si no hay compare-at real -> sin descuento -> remover
    if(!compareEl || !compareEl.textContent || !compareEl.textContent.trim()){
      removeBadge(offerGroup);
      return;
    }

    var price=numFromText(priceEl.textContent);
    var compare=numFromText(compareEl.textContent);

    // Si no hay descuento real -> remover
    if(!price || !compare || compare<=price){
      removeBadge(offerGroup);
      return;
    }

    var pct=Math.round(((compare-price)*100)/compare);
    if(!(pct>0)){
      removeBadge(offerGroup);
      return;
    }

    offerGroup.classList.add('ironside-price-ar__offer');

    var badge=offerGroup.querySelector('.ironside-price-ar__badge');
    if(!badge){
      badge=document.createElement('span');
      badge.className='ironside-price-ar__badge';
      badge.innerHTML='<span data-ironside-pct></span>% OFF';
      priceEl.insertAdjacentElement('afterend',badge);
    }
    var pctEl=badge.querySelector('[data-ironside-pct]');
    if(pctEl) pctEl.textContent=String(pct);
  }

  function updateAll(){
    var list=document.querySelectorAll('product-price');
    for(var i=0;i<list.length;i++) ensure(list[i]);
  }

  function rafThrottle(fn){
    var locked=false;
    return function(){
      if(locked) return;
      locked=true;
      requestAnimationFrame(function(){locked=false;fn();});
    };
  }

  function observeProductPrice(pp){
    if(pp.__ir_price_observed) return;
    pp.__ir_price_observed=true;

    var run=rafThrottle(function(){ensure(pp);});
    var mo=new MutationObserver(run);

    // 🔥 clave: observar el product-price (no solo priceContainer)
    mo.observe(pp,{childList:true,subtree:true,characterData:true});
    pp.__ir_price_mo=mo;

    ensure(pp);
  }

  function init(){
    var list=document.querySelectorAll('product-price');
    for(var i=0;i<list.length;i++) observeProductPrice(list[i]);
  }

  function bindVariantPickerFallback(){
    var vp=document.querySelector('variant-picker');
    if(!vp) return;

    vp.addEventListener('change',function(e){
      var t=e.target;
      if(t && t.matches('input[type="radio"][data-variant-id]')){
        // 2 disparos cortos para cubrir render async
        updateAll();
        setTimeout(updateAll,80);
      }
    },{passive:true});
  }

  function boot(){
    init();
    bindVariantPickerFallback();

    // Si Horizon re-renderiza bloques completos, detectamos nuevos product-price
    var scheduled=false;
    var mo=new MutationObserver(function(muts){
      if(scheduled) return;
      for(var i=0;i<muts.length;i++){
        var m=muts[i];
        if(!m.addedNodes) continue;
        for(var j=0;j<m.addedNodes.length;j++){
          var n=m.addedNodes[j];
          if(!n||n.nodeType!==1) continue;
          if((n.matches&&n.matches('product-price'))||(n.querySelector&&n.querySelector('product-price'))){
            scheduled=true;
            requestAnimationFrame(function(){scheduled=false;init();});
            return;
          }
        }
      }
    });
    mo.observe(document.body,{childList:true,subtree:true});
  }

  if(document.readyState==='loading'){
    document.addEventListener('DOMContentLoaded',boot,{once:true});
  }else{
    boot();
  }
})();